const Sponsors = {
  Plural: "Sponsors",
  Single: "Sponsor",
  ModalForm: false,
  DefaultSorting: "name",
  DefaultSortingType: "asc",
  Columns: [
    { name: "", label: "#", type: "counter" },
    { name: "id", dbName: "id", label: "ID", sortable: true, required: true, type: "text" },
    { name: "name", dbName: "name", label: "Name", sortable: true, required: true, type: "text" },
    {
      name: "logo",
      dbName: "logo",
      label: "Logo",
      type: "image",
      // Logo is stored as a full blob URL; only prefix relative paths.
      format: (row: any) => {
        if (!row.logo) return "";
        const src = String(row.logo).startsWith("http") ? row.logo : `${process.env.VUE_APP_ASSETS_URL}/${row.logo}`;
        return `<img src="${src}" style="max-height:30px"/>`;
      },
    },
    {
      name: "isActive",
      dbName: "isActive",
      label: "Active",
      sortable: true,
      type: "text",
      format: (row: any) => (row.isActive ? "Yes" : "No"),
    },
  ],
  Filters: [],
  PrimaryKey: "id",
  Actions: {
    addLink: "/sponsors/add/",
    editLink: "/sponsors/edit/",
  },
};

export default Sponsors;
